// extracted by mini-css-extract-plugin
export default {"wrapper":"Topbar_wrapper__mMRkp","navigation":"Topbar_navigation__zYydK"};